import { Auditable } from '../base/auditable';
export class ReferringPhysicianView extends Auditable {
    public LastName: string;
    public CellPhone: string;
    public AddressStreet: string;
    public AddressDpto: string;
    public AddressNumber: string;
    public Floor: string;
    public Email: string;
    public Locality: string;
    public FirstName: string;
    public Country: string;
    public Province: string;
    public Relevance: string;
    public Sex: string;
    public LaborPhone: string;
    public PersonalPhone: string;
    public NationalRegistration: string;
    public ProvincialRegistration: string;
    public SpecialityRegistration: string;
    public Id: number;
}

